// Generated by CoffeeScript 2.7.0
var deleteAdministratorPopover;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

export default deleteAdministratorPopover = Vue.extend({
  components: {
    'Popover': Popover
  },
  props: {
    resources: {
      type: String
    },
    administrator: {
      type: Object
    }
  },
  template: `<Popover  position="bottom center"
          :caret='true'
          type="confirm"
          size="default"
          ref='deletePopoverRef'>
  <span class='normal-action' slot='trigger'>
    <button class="text-btn btn-danger">移除</button>
  </span>
  <div class="popover-confirm-content" slot="content">
    <div class="popover-confirm-title">确认移除成员</div>
    <div class="popover-confirm-footer">
      <div class="btn btn-default btn-small" @click='closeDeletePopover'>取消</div>
      <div class="btn btn-danger btn-small" @click='deleteAdministrator(administrator)' >删除</div>
    </div>
  </div>
</Popover>`,
  methods: {
    deleteAdministrator: function(administrator) {
      this.closeDeletePopover();
      return Skylark.Libs.Ajax.delete(`${this.resources}/${administrator.id}`, {
        contentType: 'application/json, text/javascript',
        responseType: 'json',
        success: () => {
          newAlertify('移除管理员成功', {
            type: 'success'
          });
          return this.$emit('deletedAdministrator', this.administrator);
        },
        error: function() {
          return newAlertify('移除管理员失败', {
            type: 'error'
          });
        }
      });
    },
    closeDeletePopover: function() {
      return this.$refs.deletePopoverRef.close();
    }
  }
});
